import { useCallback } from 'react';
import { checkCurrentAndChangePlan } from '../../services/pricing/PricingService';
import { AccountType } from '../../types/account/AccountType';
import { showCustomDialog } from '../../helpers/DialogHelper';
import { t } from 'i18next';

const useChangePlan = () => {
  const tryChangePlan = useCallback(async (priceId: string, accountType: AccountType) => {
    try {
      return await checkCurrentAndChangePlan(priceId, accountType);
    } catch (err) {
      throw err;
    }
  }, []);

  return { tryChangePlan };
};

export default useChangePlan;
